export const DATE_DISPLAY_FORMAT = 'MM/DD/YYYY';
export const DATE_SR_FORMAT = 'MMMM D, YYYY';
export const START_DATE = 'startDate';
export const END_DATE = 'endDate';
export const DISPLAY_FORMAT = 'L';
export const ISO_FORMAT = 'YYYY-MM-DD';
export const ISO_MONTH_FORMAT = 'YYYY-MM';
export const HORIZONTAL_ORIENTATION = 'horizontal';
export const VERTICAL_ORIENTATION = 'vertical';
export const VERTICAL_SCROLLABLE = 'verticalScrollable';
export const ICON_BEFORE_POSITION = 'before';
export const ICON_AFTER_POSITION = 'after';
export const ANCHOR_LEFT = 'left';
export const ANCHOR_RIGHT = 'right';
export const OPEN_DOWN = 'down';
export const OPEN_UP = 'up';
export const DAY_SIZE = 39;
export const BLOCKED_MODIFIER = 'blocked';
export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
